import React, { useEffect } from "react";
import CompanyTotalDetails from "../../components/sections/front/CompanyTotalDetails";
import CompanyCard from "../../components/sections/front/CompanyCard";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { organizationDetailsUser } from "../../services/organizationService";
import MenuCard from "../../components/sections/front/MenuCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyDetails } from "../../redux/slice/companyDetailsSlice";

const menuItems = [
  {
    label: "Create Company",
    icon: "fa-regular fa-plus",
    link: "/manage-company",
  },
  { label: "Saved items", icon: "fa-regular fa-bookmark", link: "/post" },
  { label: "Jobs List", icon: "fa-fw fa-solid fa-briefcase", link: "/post" },
  { label: "Application", icon: "fa-regular fa-newspaper", link: "/post" },
];

const CompanyDetails = () => {
  const { slug } = useParams();

  const dispatch = useDispatch();

  const {
    data: company,
    loading,
    error,
  } = useSelector((state) => state.companyDetails);

  useEffect(() => {
    if (slug) {
      dispatch(fetchCompanyDetails(slug));
    }
  }, [slug]);

  if (loading) return <div>Loading...</div>;

  if (!company) return <div>No company found</div>;

  return (
    <div>
      <CompanyTotalDetails organization={company} />
    </div>
  );
};

export default CompanyDetails;
